import script from "./FranchiseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseDetail.vue?vue&type=script&setup=true&lang=js"

import "./FranchiseDetail.vue?vue&type=style&index=0&id=250ad6e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250ad6e3"]])

export default __exports__